import { create } from 'zustand';

export const MAX_COMPARISON_CHANNELS = 8;

export const useChartComparison = create((set, get) => ({
    channels: [],
    isOpen: false,

    canAddChannel: (uuid) => {
        const { channels } = get();
        return Boolean(uuid)
            && !channels.some((channel) => channel.uuid === uuid)
            && channels.length < MAX_COMPARISON_CHANNELS;
    },

    addChannel: (channel) => {
        if (!channel?.uuid || !get().canAddChannel(channel.uuid))
            return false;

        set((state) => ({
            channels: [...state.channels, { ...channel }]
        }));
        return true;
    },

    removeChannel: (uuid) => {
        set((state) => {
            const channels = state.channels.filter((channel) => channel.uuid !== uuid);
            return {
                channels,
                isOpen: channels.length === 0 ? false : state.isOpen
            };
        });
    },

    clearChannels: () => set({ channels: [], isOpen: false }),

    setPeriodForAll: (start, finish) => set((state) => ({
        channels: state.channels.map((channel) => ({ ...channel, start, finish }))
    })),

    openComparison: () => {
        if (get().channels.length > 0)
            set({ isOpen: true });
    },

    closeComparison: () => set({ isOpen: false })
}));